import type { PlaceFromWebsiteResponse } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const placeWebsiteApi = {
  async read(
    businessId: string,
    input: { url: string; locale: 'de' | 'en' },
  ): Promise<PlaceFromWebsiteResponse> {
    const res = await api.api.businesses[':businessId']['ai-studio']['place-from-website'].$post({
      param: { businessId },
      json: input,
    })
    return unwrap<PlaceFromWebsiteResponse>(res)
  },
}
